module.exports = Object.assign(
  { devNote: require('./dev-note') },
  require('./combinators'),
  require('./configuration'),
  require('./functions'),
  require('./objects'),
  require('./strings')
);
